import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { supabase } from '../supabase/client' // Make sure to import supabase client

const LoginPage = ({ onLogin }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isSignup, setIsSignup] = useState(false)
  const [showEmailForm, setShowEmailForm] = useState(false)
  const [otpEmail, setOtpEmail] = useState('')
  const [showOtpInput, setShowOtpInput] = useState(false)
  const [alertMessage, setAlertMessage] = useState('')
  const [alertType, setAlertType] = useState('') // 'error' or 'success'
  const navigate = useNavigate()
  const location = useLocation()

  // Removed debugging useEffect for mount and unmount

  async function handleSubmit(e) {
    e.preventDefault()
    setError(null)
    if (isSignup) {
      const { data, error } = await supabase.auth.signUp({ email, password })
      if (error) {
        setError(error.message)
      } else {
        // Signup successful, auth state change will handle navigation
      }
    } else {
      const { data, error } = await supabase.auth.signInWithPassword({ email, password })
      if (error) {
        setError(error.message)
      } else {
        onLogin() // Retain any additional logic if needed
      }
    }
  }

  // Add Google login handler
  function handleGoogleLogin() {
    supabase.auth.signInWithOAuth({ provider: 'google' })
  }

  // Add new function for OTP login
  const handleOtpLogin = async () => {
    if (!otpEmail) {
      setAlertMessage('Пожалуйста, введите ваш email')
      setAlertType('error')
      return
    }
    const { error } = await supabase.auth.signInWithOtp({ email: otpEmail })
    if (error) {
      setAlertMessage('Ошибка при отправке OTP: ' + error.message)
      setAlertType('error')
    } else {
      setAlertMessage('OTP код отправлен. Вы будете перенаправлены для ввода кода.')
      setAlertType('success')
      navigate('/verify-otp', { state: { email: otpEmail } }) // Pass email to VerifyOtpPage
    }
  }

  return (
    <>
      <div className="container">
        <div className="header">
          <div className="logo">
            Business <span>Evolution AI</span>
          </div>
        </div>

        <div className="info-box">
          <h2>Раскройте свой профессиональный потенциал</h2>
          <div style={{ margin: '0 0 10px', padding: 0 }}>
            <div
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: '#e9f5ff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              💰 Узнайте, за какие способности вам готовы платить больше всего
            </div>
            <div
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: '#e9f5ff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              🏆 Определите таланты, которые принесут вам успех без выгорания
            </div>
            <div
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: '#e9f5ff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              🌟 Развивайте свои таланты эффективно
            </div>
            <div
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: '#e9f5ff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              🔍 Получите инсайты для карьерного роста
            </div>
            <div
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: '#e9f5ff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              🤝 Получите персонализированные советы
            </div>
            <div
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: '#e9f5ff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              👥 Присоединяйтесь к сообществу за поддержкой
            </div>
            <div
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: '#e9f5ff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              🎯 Установите четкие цели
            </div>
            <div
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: '#e9f5ff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              📊 Мониторьте ваш прогресс
            </div>
            <div
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: '#e9f5ff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              📈 Увеличьте свою продуктивность
            </div>
            <div
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: '#e9f5ff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              💼 Создайте идеальный график работы
            </div>
          </div>
          <p>
            Институт Gallup на протяжении 25 лет исследовал более 1.000.000 высокоэффективных
            менеджеров по всему миру. Главный вывод исследования: ключевым фактором успеха является
            применение врожденных талантов человека.
          </p>
          <p>
            Мы создали точный и быстрый сервис для выявления ваших врожденных талантов и определения
            степени их развития. Персонализированный тест займет всего 5-10 минут.
          </p>
        </div>

        <h2>Вход в систему</h2>

        {alertMessage && (
          <div
            style={{
              backgroundColor: alertType === 'error' ? 'pink' : 'lightgreen',
              padding: '10px',
              marginBottom: '10px',
              border: '1px solid',
              borderRadius: '4px',
              textAlign: 'center',
              fontSize: '14px',
              color: 'black',
            }}
          >
            {alertMessage}
            <button
              onClick={() => setAlertMessage('')}
              style={{
                marginLeft: '10px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                color: 'red',
              }}
              aria-label="Закрыть оповещение"
            >
              &times;
            </button>
          </div>
        )}
        {showOtpInput && (
          <>
            <button
              onClick={() => setShowOtpInput(false)}
              className="btn"
              style={{ marginTop: '20px', marginBottom: '20px' }}
              aria-label="Назад к выбору метода входа"
            >
              ←
            </button>
            <div className="form-group">
              <input
                type="email"
                value={otpEmail}
                onChange={(e) => setOtpEmail(e.target.value)}
                placeholder="Введите email для отправки кода"
                style={{ marginRight: '10px' }}
              />
              <button onClick={handleOtpLogin} className="btn">
                Отправить код на Email
              </button>
            </div>
          </>
        )}
        {showEmailForm && (
          <>
            <button
              onClick={() => setShowEmailForm(false)}
              className="btn"
              aria-label="Назад к выбору метода входа"
            >
              ←
            </button>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Введите ваш email"
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Пароль:</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Введите ваш пароль"
                />
              </div>

              {error && <div className="error">{error}</div>}

              <button type="submit" className="btn">
                {isSignup ? 'Зарегистрироваться' : 'Войти'}
              </button>
              <p
                onClick={() => setIsSignup(!isSignup)}
                style={{ cursor: 'pointer', color: 'blue', textAlign: 'center', marginTop: '10px' }}
              >
                {isSignup
                  ? 'Уже есть аккаунт? Переключиться на вход'
                  : 'Нет аккаунта? Переключиться на регистрацию'}
              </p>
              <p
                onClick={() => navigate('/reset-password')}
                style={{ cursor: 'pointer', color: 'blue', textAlign: 'center', marginTop: '10px' }}
              >
                Забыли пароль?
              </p>
            </form>
          </>
        )}
        {!showEmailForm && !showOtpInput && (
          <>
            <button onClick={() => setShowOtpInput(true)} className="btn">
              Вход по коду из Email
            </button>

            <button onClick={() => setShowEmailForm(!showEmailForm)} className="btn">
              Вход по паролю
            </button>
            <button type="button" className="btn btn-secondary" onClick={handleGoogleLogin}>
              Войти через Google
            </button>
          </>
        )}
      </div>
    </>
  )
}

export default LoginPage
